/**
 * Pricing visibility — hide item pricing flag presentation helper.
 * Does not change commercial totals; only whether unit/line prices render.
 */

export function renderPricingVisibility(input: {
  hideItemPricing?: boolean | null;
  /** Force-hide (e.g. REMOVED VO lines). */
  forceHide?: boolean;
}): { hidePrice: boolean } {
  return {
    hidePrice: Boolean(input.forceHide) || Boolean(input.hideItemPricing),
  };
}
